import type { FC } from "react"
import { useTranslation } from "react-i18next"

import type { IDateFormat } from "@/models/date/date"
import { translateDate } from "@/utils/date"
import type { DateTime } from "luxon"

interface IDateDisplayProps {
  /**
   * The format configuration for the date
   */
  format?: IDateFormat

  /**
   * The date
   */
  value: DateTime | null
}

/**
 * A component that properly formats and internationalizes the provided date.
 * The text is unstyled so it inherits the surrounding typography.
 *
 * @example
 * <DateDisplay value={DateTime.now()} format={{
 *   dateStyle: "medium"
 * }} />
 */
export const DateDisplay: FC<IDateDisplayProps> = ({ format, value }) => {
  const { i18n } = useTranslation()

  if (!value?.isValid) {
    return null
  }

  return <span>{translateDate(i18n, value, format)}</span>
}
